import { useState } from "react";
import { useTranslation } from "./i18n";

function FAQ({ question, answer }: { question: string; answer: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item ${open ? "faq-open" : ""}`} onClick={() => setOpen(!open)}>
      <div className="faq-question">
        <span>{question}</span>
        <span className={`faq-arrow ${open ? "faq-arrow-open" : ""}`}>▾</span>
      </div>
      {open && <div className="faq-answer">{answer}</div>}
    </div>
  );
}

export function HelpPage() {
  const { t } = useTranslation();

  const faqs = [
    { q: t("help.faq1_q"), a: t("help.faq1_a") },
    { q: t("help.faq2_q"), a: t("help.faq2_a") },
    { q: t("help.faq3_q"), a: t("help.faq3_a") },
    { q: t("help.faq4_q"), a: t("help.faq4_a") },
    { q: t("help.faq5_q"), a: t("help.faq5_a") },
    { q: t("help.faq6_q"), a: t("help.faq6_a") },
  ];

  return (
    <>
      <div className="card">
        <h2>{t("help.faq")}</h2>
        <div className="faq-list">
          {faqs.map((faq, i) => (
            <FAQ key={i} question={faq.q} answer={faq.a} />
          ))}
        </div>
      </div>

      <div className="card">
        <h2>{t("help.contact")}</h2>
        <div className="contact-grid">
          <div className="contact-item">
            <span className="contact-icon">📧</span>
            <div>
              <div className="muted" style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 4 }}>Email</div>
              <a href="mailto:support@restify.com" style={{ color: "var(--accent-primary)", textDecoration: "none" }}>support@restify.com</a>
            </div>
          </div>
          <div className="contact-item">
            <span className="contact-icon">📞</span>
            <div>
              <div className="muted" style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 4 }}>Phone</div>
              <a href="tel:+48666666666" style={{ color: "var(--text-main)", textDecoration: "none" }}>+48 666 666 666</a>
            </div>
          </div>
          <div className="contact-item">
            <span className="contact-icon">📍</span>
            <div>
              <div className="muted" style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 4 }}>Address</div>
              <span>Ul. Aleja Jana Pawła II</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
